import { Injectable } from '@angular/core';
import { FatherService } from './father.service';
import { Observable } from 'rxjs';
import { TariffInterface } from '../tariffs/tariff.interface';

@Injectable({
  providedIn: 'root'
})
export class TariffService extends FatherService {

  getTariffs(): Observable<TariffInterface[]> {
    return this.get('/api-license/tariff');
  }

  createTariff(data: TariffInterface): Observable<any> {
    return this.post('/api-license/tariff', data);
  }

  updateTariff(id: number, data: TariffInterface): Observable<any> {
    return this.patch(`/api-license/tariff/${id}`, data);
  }

  deleteTariff(id: number): Observable<any> {
    return this.delete(`/api-license/tariff/${id}`);
  }
}
